<template>
  <v-autocomplete
    v-model="value"
    v-on="inputListeners"
    :items="items"
    item-text="descricao_full"
    item-value="id"
    v-bind="$attrs"
    :loading="loading"
    :hide-details="hideDetails"
  >
    <template v-slot:progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template v-slot:prepend-item v-if="multiplaSelecao && items.length">
      <v-list-item
        v-if="value.length === items.length"
        class="pl-14px py-2"
        @click="value = []"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="value = Helpers.arrayColumn(items, 'id')"
      >
        <v-icon v-if="value.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template v-slot:selection="{item}" v-if="multiplaSelecao">
      <template v-if="value.indexOf(item.id) < qtdeVisivelSelecionados">
        {{item.descricao_full }}<template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="value.indexOf(item.id) === qtdeVisivelSelecionados">
        <span class="ml-1 text-grat-900">(+ {{value.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import SegmentoAPI from "../../../api/segmento"
import {arrayColumn} from "@/helpers";

export default {
  name: "SysSegmentoAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 1
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    idsGrupo: {
      type: Array,
      default: () => ([])
    },
    idsFilial: {
      type: Array,
      default: () => ([])
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    exibir_apenas_segmentos_com_produtos_ativos: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: [],
    loading: false,
    timer_buscar_items: null
  }),
  computed: {
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple)
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            vm.value = values;
          }
        }
      )
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        if ([null, undefined].includes(newValue)) {
          newValue = this.multiplaSelecao ? [] : '';
        }

        this.$emit("update:modelValue", newValue)
      }
    }
  },
  watch: {
    idsGrupo(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
    idsFilial(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems () {
      this.loading = true
      const headers = this.Helpers.iniciarRequisicao()
      const parametros = {
        grupos: this.idsGrupo,
        filiais: this.idsFilial,
        exibir_apenas_segmentos_com_produtos_ativos: this.exibir_apenas_segmentos_com_produtos_ativos ? 'S' : 'N'
      };

      SegmentoAPI.getSegmentosDrp(headers, parametros)
        .then((response) => {
          const {token, segmentos} = response.data;
          localStorage.token = token;
          this.items = segmentos;
          this.loading = false;
          this.atualizarFiliaisSelecionadas();
        })
        .catch(() => this.Helpers.logout())
    },
    atualizarFiliaisSelecionadas() {
      if (!this.multiplaSelecao) return;

      const segmentos = this.items.filter(segmento => this.value.some(id => `${id}` === `${segmento.id}`));
      this.value = arrayColumn(segmentos, 'id');
    },
    apendarVirgula (item) {
      const indexOf = this.value.indexOf(item.id)
      return indexOf !== this.value.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
